import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import type { SyntheticEvent } from 'react';

import { CustomDivider } from '@/components/ui/swimlane/layout/headers/menu/styled';

import type {
  SLCardContextMenuOption,
  SLCardContextMenuSlotData,
} from './hooks/useSLCardContextMenuSlots';

export interface ISLCardContextMenuSlotProps {
  menuSlot: SLCardContextMenuSlotData;
  isLast: boolean;
  onCloseMenu?: () => void;
  closeContextMenu?: () => void;
}

export function SLCardContextMenuSlot({
  menuSlot,
  isLast,
  onCloseMenu,
  closeContextMenu,
}: ISLCardContextMenuSlotProps) {
  const onClick = (option: SLCardContextMenuOption, event: SyntheticEvent<HTMLElement>) => {
    onCloseMenu?.();
    option.action(event);
    closeContextMenu?.();
  };

  return (
    <>
      {menuSlot.menuOptions.map((menuOption) => (
        <MenuItem
          key={menuOption.label}
          onClick={(event) => {
            onClick(menuOption, event);
          }}
          disabled={menuOption.isDisabled}
          dense={true}
        >
          {menuOption.icon && <ListItemIcon>{menuOption.icon}</ListItemIcon>}
          <ListItemText primary={menuOption.label} />
        </MenuItem>
      ))}
      {!isLast && <CustomDivider />}
    </>
  );
}
